import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools'
import '../../gigproApi'

const queryClient = new QueryClient()

// Shell self-renders in prod (Gatsby = webpack, no Vite strip plugin); gate it.
const isDev = process.env.NODE_ENV === 'development'

export const ReactQueryProvider: React.FunctionComponent<{
  children: React.ReactNode
}> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {isDev && (
        <TanStackDevtools
          plugins={[
            { name: 'TanStack Query', render: <ReactQueryDevtoolsPanel /> },
            formDevtoolsPlugin(),
          ]}
        />
      )}
    </QueryClientProvider>
  )
}
